var _defs, _path, _path2, _path3, _path4, _path5, _use;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "140px",
    width: "140px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-3.49%",
    x2: "100.83%",
    y1: "17.02%",
    y2: "92.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "14%",
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61%",
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M106.687 35.2742c-.186-1.0977-.967-2-2.0244-2.338s-2.2148-.057-3.0002.73L86.2473 49.166l-12.12-23.1455c-.5133-.9786-1.525-1.5914-2.6273-1.5914s-2.114.6128-2.6273 1.5914l-6.6277 12.656L45.62 7.5726c-.603-1.1297-1.8588-1.746-3.118-1.5297s-2.2394 1.216-2.4335 2.4827L24 111.701l42.9727 24.1654c2.6985 1.5113 5.985 1.5113 8.6836 0L119 111.701l-12.313-76.427z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M23.8333 111.7187L39.9655 8.4906c.1972-1.266 1.1818-2.264 2.445-2.4786s2.522.4028 3.126 1.5327L62.22 38.662l6.65-12.6615c.515-.979 1.5303-1.592 2.6366-1.592s2.1215.613 2.6366 1.592l45.0227 85.718H23.8333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M79.566 71.5074L62.2124 38.6472l-38.379 73.0715L79.566 71.5074z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M119.1666 111.7187l-12.356-76.4603c-.1867-1.098-.9703-2-2.0315-2.34s-2.2226-.057-3.0107.7302l-77.935 78.069 43.1234 24.1834c2.708 1.512 6.006 1.512 8.714 0l43.4958-24.1834z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M106.8105 35.2584c-.1867-1.098-.9703-2-2.0315-2.34s-2.2226-.057-3.0107.7302L86.3 49.1562 74.1365 26c-.515-.979-1.5303-1.592-2.6366-1.592s-2.1215.613-2.6366 1.592l-6.65 12.6615L45.529 7.5447c-.605-1.1302-1.8653-1.7466-3.13-1.5304S40.153 7.231 39.958 8.498L23.8333 111.7187h-.052l.052.0596.4245.2085 77.488-77.5775c.7877-.7915 1.952-1.076 3.016-.737s1.849 1.2445 2.0338 2.3457l12.2518 75.775.1192-.0745-12.356-76.4603zm-82.8357 76.3188L39.9655 9.228c.1948-1.267 1.1784-2.2675 2.442-2.4837s2.524.4 3.13 1.5304L62.22 39.392l6.65-12.6615c.515-.979 1.5303-1.592 2.6366-1.592s2.1215.613 2.6366 1.592l11.9167 22.664-62.0858 62.1827z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a52714",
    opacity: 0.2,
    d: "M75.6708 135.1722c-2.708 1.512-6.006 1.512-8.714 0L23.9376 111.056l-.1043.663 43.1234 24.176c2.708 1.512 6.006 1.512 8.714 0l43.4958-24.176-.1117-.6852-43.384 24.1387z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.a6f24a5afb045e3a90d72a16d7e325ce.svg";
export { ForwardRef as ReactComponent };